import { Navi, NaviDivider, NaviKey, NaviType } from "./type";
import { MyOrganizationWithMembers } from "@maven-rest/auth/Organization.dto";
import { BundleItemFunctionalityType } from "@maven-rest/billing/Bundle.dto";
import { isSubscribedFunctionality } from "@maven-rest/billing/SubscriptionLicense.lib";

export type NaviListType = (Navi | NaviDivider)[];

export const getNaviList = ({ organizations }: { organizations: MyOrganizationWithMembers[] }): NaviListType => {
  const isEConsentLimitless = organizations?.some((organization) =>
    isSubscribedFunctionality(organization?.licenses || [], BundleItemFunctionalityType.Docs_EConsent_Limitless)
  );

  return [
    {
      type: NaviType.Navi,
      key: NaviKey.MyDocuments,
      label: "My Documents",
      link: {
        url: "/my/folders",
      },
      startIcon: "file-text",
    },
    {
      type: NaviType.Navi,
      key: NaviKey.SignStatus,
      label: "Sign Status",
      link: {
        url: "/sign",
      },
      startIcon: "sign",
      isHidden: process.env.REACT_APP_FEATURE_SIGN !== "true",
    },
    {
      type: NaviType.Navi,
      key: NaviKey.Contacts,
      label: "Contacts",
      link: {
        url: "/contacts",
      },
      startIcon: "address-book",
    },
    {
      type: NaviType.Divider,
      isVisibleLine: true,
    },
    {
      type: NaviType.Navi,
      key: NaviKey.Archiver,
      label: "Archiver",
      link: {
        url: "/archiver/folders",
      },
      startIcon: "cloud",
    },
    {
      type: NaviType.Navi,
      key: NaviKey.Templates,
      label: "Template",
      link: {
        url: "/templates",
      },
      startIcon: "template2",
      isHidden: process.env.REACT_APP_FEATURE_COMPOSER_TEMPLATE !== "true",
    },
    {
      type: NaviType.Divider,
      isVisibleLine: true,
      isHidden: !isEConsentLimitless,
    },
    {
      type: NaviType.Navi,
      key: NaviKey.EConsent,
      label: "eConsent",
      link: {
        url: "/econsent",
      },
      startIcon: "list-check",
      isHidden: !isEConsentLimitless,
    },
    {
      type: NaviType.Divider,
      isVisibleLine: true,
      isHidden: process.env.REACT_APP_FEATURE_TMF !== "true",
    },
    {
      type: NaviType.Navi,
      key: NaviKey.TMF,
      label: "Maven TMF",
      link: {
        url: `${process.env.REACT_APP_TMF_FE_URL}`,
        isExternal: true,
        target: "_blank",
      },
      endIcon: "open",
      isHidden: process.env.REACT_APP_FEATURE_TMF !== "true", // NOTE: production 환경에서는 tmf 이동 버튼 숨김
    },
  ];
};

interface MenuConfig {
  /** organization이 존재하지 않아도 어떠한 액션을 허용 */
  allowEmptyOrganization?: boolean;
}

/** sidemenu 외에 화면을 제어하는 config, key name은 navis slug를 기준으로 */
export const additionalConfigs: { [key: string]: MenuConfig } = {
  my: {},
  sign: {
    allowEmptyOrganization: true,
  },
  econsent: {},
  archiver: {},
  templates: {
    allowEmptyOrganization: true,
  },
};
